import {
    Injectable, inject
} from "@angular/core";

import { MatDialog } from "@angular/material/dialog";

import { UpdatePasswordSubmitFormComponent } from "../dialogs/update-password-submit-form/update-password-submit-form.component";

/**
 * Dialog service for user account-related dialogs.
 *
 * Provides methods to open user account management dialogs. Each dialog is self-contained
 * and handles its own submission logic and notifications internally.
 *
 * @pattern dialog-service
 * @providedIn root
 *
 * @example
 * ```typescript
 * // Inject and open the update-password dialog:
 * private readonly _userDialogService = inject(UserDialogService);
 *
 * this._userDialogService.openUpdatePassword();
 * ```
 */
@Injectable({
    providedIn: "root"
})
export class UserDialogService {
    private readonly _dialog = inject(MatDialog);

    /**
     * Opens the {@link UpdatePasswordSubmitFormComponent} dialog.
     *
     * The component handles form submission, success notifications, and error handling
     * internally — no `afterClosed()` subscription is required here.
     */
    openUpdatePassword(): void {

        this._dialog.open(UpdatePasswordSubmitFormComponent, {
            width: "600px",
            maxHeight: "100%",
            disableClose: true
        });
    }
}
